import { Component, inject, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ActivatedRoute, Router } from '@angular/router';
import { LocalStorageCacheService } from '@app/services/local-storage-cache.service';

@Component({
  selector: 'app-pdf-viewer-full-screen',
  templateUrl: './pdf-viewer-full-screen.component.html',
  styleUrl: './pdf-viewer-full-screen.component.scss',
})
export class PdfViewerFullScreenComponent implements OnInit, OnDestroy {
  @ViewChild('content') content: any;
  private modalService = inject(NgbModal);
  documentId: any;
  fileName: string | undefined | null;
  
  fileUrl = '';

  constructor(
    private route: ActivatedRoute,
    private localStorageCacheService: LocalStorageCacheService,
    private router: Router
  ) {
  }

  ngOnDestroy() {
    this.onClose();
  }

  ngOnInit() {
    this.documentId = this.route.snapshot.paramMap.get('documentId');
    this.fileName = this.route.snapshot.queryParamMap.get('filename');
    this.fileUrl = this.localStorageCacheService.get(this.documentId);

    if (!this.fileUrl) {
      this.router.navigate(['documents', this.documentId]);
      return;
    }

    setTimeout(() => {
      this.modalService.open(this.content, { fullscreen: true, modalDialogClass: 'dark-modal' }).result.then(
        (result) => {},
        (reason) => {
          this.router.navigate(['documents', this.documentId]);
        }
      );
    }, 1);
  }

  onExport() {
    this.onClose();
  }

  onClose() {
    this.modalService.dismissAll();
  }
}
